import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { SplitButton } from "primereact/splitbutton";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { settingService } from "../../../services/extensions";
import PmAllocation from "./pmAllocation"
import { toast } from "react-toastify";
import { Util } from "../../../services";

function ProjectMapping() {
  const [projects, setProjects] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const dt = useRef(null);
  const [clickedUserId, setClickedUserId] = useState("");
  const [mAction, setmAction] = useState(false);
  const [allCode, setAllCode] = useState([]);
  const [selectCode, setSelectCode] = useState([]);

  useEffect(() => {
    getProjects();
  }, []);

  const getProjects = () => {
    settingService.getAllProjectType().then((resp) => {
      setProjects(resp.data.data);
      setAllProjects(resp.data.data);
      let proCode = resp.data.data.map((item) => {
        return item.code;
      });
      setAllCode(proCode);
    });
  };

  const projectId = (item) => {
    return item?.customers?.title;
  };
  const region = (item) => {
    return item?.customers?.legalEn?.code;
  };
  const projectManagerId = (item) => {
    if (item.pmDetails != null) {
      let projectManager = item.pmDetails?.firstName + " " + item.pmDetails?.lastName
      return <span style={{ textTransform: 'capitalize' }}>{projectManager}</span>
    } else {
      return
    }
  };
  const buName = (item) => {
    return item.businessUnits?.code
  }
  const projectType = (item) => {
    return item.projectTypes?.title
  }
  const onPMAction = (rowData) => {
    setClickedUserId(rowData.id);
    setmAction(true);
  };
  const assignProjectManager = (data) => {
    let param = {
      id: clickedUserId,
      projectManagerId: data.manager.id,
    };
    try {
      settingService.updateProjectManager(param).then((resp) => {
        if (resp) {
          toast.info("Project Manager changed");
          getProjects();
        }
      });
    } catch (error) {
      toast.error("Unable to assign Project Manager");
    }

  };
  const exportExcel = () => {
    Util.exportExcel(projects, "Projects");
  };

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };
  const cols = [
    { field: "id", header: "Id" },
    { field: "code", header: "Code" },
    { field: "title", header: "Title" },
    { field: "status", header: "Status" },
  ];
  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));
  const exportPdf = () => {
    Util.exportPdf(exportColumns, projects, "Projects");
  };
  const items = [
    {
      label: "CSV",
      icon: "pi pi-file-export",
      command: () => {
        exportCSV();
      },
    },
    {
      label: "EXCEL",
      icon: "pi pi-file-excel",
      command: () => {
        exportExcel();
      },
    },
    {
      label: "PDF",
      icon: "pi pi-file-pdf",
      command: () => {
        exportPdf();
      },
    },
  ];

  const ManagerAction = () => {
    const headerText = "PM Allocation";
    return (
      <Dialog
        header={headerText}
        visible={mAction}
        onHide={() => setmAction(false)}
        style={{ width: "375px", height: "26vh" }}>
        <PmAllocation assignProjectManager={(data) => assignProjectManager(data)} onClose={(e) => setmAction(false)} />
      </Dialog>
    );
  };

  const actionBody = (rowData) => {
    return (
      <Button
        icon="pi pi-user-edit"
        className="p-button-rounded p-button-primary p-button-text"
        arial-label="Bookmark"
        onClick={() => onPMAction(rowData)}
        tooltip="Change PM"
        tooltipOptions={{ position: "left" }} />
    )
  }
  const rightDropDownTemp = () => {
    return (
      <React.Fragment>
        <SplitButton
          style={{ marginLeft: "20px" }}
          label="Export"
          icon="pi pi-download"
          className="p-button-info"
          model={items}
          appendTo="self" />
      </React.Fragment>
    );
  };
  const leftDropDownTemp = () => {
    return (
      <React.Fragment>
        <div className="mt-3 mr-3">
          <h3>Select Project Code</h3>
        </div>
        <Dropdown
          filter
          style={{ width: "250px" }}
          placeholder="Select Project Code"
          options={allCode}
          value={selectCode}
          onChange={(e) => filterCode(e.value, allProjects)}
          appendTo="self"
        ></Dropdown>
      </React.Fragment>
    );
  };

  const fetchStatus = (status) => {
    if (status === 0) return "INACTIVE";
    if (status === 1) return "ACTIVE";
    if (status === 2) return "REJECT";
    if (status === 3) return "UPCOMING";
    if (status === 4) return "ARCHIVE";
  };

  const fetchStatusColor = (status) => {
    if (status === 0) return "red";
    if (status === 1) return "#008000";
    if (status === 2) return "red";
    if (status === 3) return "#cb7205";
    if (status === 4) return "rgb(222 204 90)";
  };

  const statusBodyTemplate = (data) => {
    return (
      <span style={{ color: fetchStatusColor(data.status), borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchStatus(data.status)}</span>
    );
  };
  const filterCode = (data, allProjects) => {
    setSelectCode(data);
    let projFilter = allProjects.filter((item) => {
      return item.code === data;
    });
    setProjects(projFilter);
  };

  
  return (
    <div>
      {ManagerAction()}
      <div>
        <Toolbar
          className="mb-2"
          right={rightDropDownTemp}
          left={leftDropDownTemp}
        ></Toolbar>
      </div>
      <div className="grid">
        <div className="col-12">
          <DataTable
            value={projects}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            editMode="row"
            ref={dt}
            selectionMode="checkbox">
            <Column
              header="Region"
              body={region}
              headerStyle={{ width: "4rem" }}
              sortable
            ></Column>
            <Column
              header="BU"
              body={buName}
              headerStyle={{ width: "4rem" }}
              sortable
            ></Column>
            <Column
              header="Client"
              body={projectId}
              headerStyle={{ width: "11rem" }}
              sortable
            ></Column>
            <Column
              field="title"
              header="Project Name"
              headerStyle={{ width: "15rem" }}
              sortable
            ></Column>
            <Column
              field="code"
              header="Project ID"
              headerStyle={{ width: "10rem" }}
              sortable
            ></Column>
            <Column
              header="Project Type"
              body={projectType}
              headerStyle={{ width: "12rem" }}
              sortable
            ></Column>
            <Column
              header="Project Manager"
              body={projectManagerId}
              headerStyle={{ width: "14rem" }}
              sortable
            ></Column>
            <Column
              header="Status"
              body={statusBodyTemplate}
              headerStyle={{ width: "8rem" }}
              style={{ width: "10%" }}
            ></Column>
            <Column
              header="Action"
              body={actionBody}
              headerStyle={{ width: "3rem" }}
            ></Column>
          </DataTable>
        </div>
      </div>
    </div>
  );
}

export default ProjectMapping;